const namespace = 'CREATE_CONTACT'

const createNamespacedActionConst = <NS extends string>(namespace: NS) => <A extends string>(action: A): `${NS}_${A}` => `${namespace}_${action}`

const createContactActionConst = createNamespacedActionConst(namespace)

export const SHOW_LOADING = createContactActionConst('SHOW_LOADING')
export const HIDE_LOADING = createContactActionConst('HIDE_LOADING')

export const OPEN_DIALOG = createContactActionConst('OPEN_DIALOG')
export const CLOSE_DIALOG = createContactActionConst('CLOSE_DIALOG')

export const CREATE_CONTACT_SUCCESS = createContactActionConst('CREATE_CONTACT_SUCCESS')
export const CREATE_CONTACT_FAILURE = createContactActionConst('CREATE_CONTACT_FAILURE')

export const REF_URL = {
  AGENT: '/api/rest/recording/person/',
  GROUP: '/api/rest/recording/group/',
  TEAM: '/api/rest/recording/team/',
} as const

export const CONTACT_TYPE = {
  NON_CALL: 'NON_CALL',
} as const
